// extracted by mini-css-extract-plugin
module.exports = {"nav-buttons":"nav-buttons--36-D7","navButtons":"nav-buttons--36-D7","nav-button":"nav-button--3B8vI","navButton":"nav-button--3B8vI"};